import { motion, useInView } from "framer-motion";
import { useRef } from "react";

interface FadeProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}

export function Fade({ children, delay = 0, y = 12, className = "" }: FadeProps) {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
